function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 32C24.8667 32 32 24.8667 32 16C32 7.13328 24.8667 0 16 0C7.13328 0 0 7.13328 0 16C0 24.8667 7.13328 32 16 32Z",
  fill: "#2775CA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4 18.5333C20.4 16.2 19.0001 15.4 16.2001 15.0667C14.2001 14.8 13.8001 14.2667 13.8001 13.3333C13.8001 12.3999 14.4668 11.8 15.8001 11.8C17.0001 11.8 17.6668 12.2 18.0001 13.2C18.0668 13.4 18.2668 13.5333 18.4668 13.5333H19.5333C19.8 13.5333 20 13.3333 20 13.0667V13C19.7333 11.5333 18.5333 10.4 17.0001 10.2667V8.66674C17.0001 8.40002 16.8001 8.20002 16.4668 8.1333H15.4668C15.2001 8.1333 15.0001 8.3333 14.9333 8.66674V10.2C12.9334 10.4667 11.6668 11.8 11.6668 13.4667C11.6668 15.6667 13.0001 16.5333 15.8001 16.8667C17.6668 17.2 18.2668 17.6 18.2668 18.6667C18.2668 19.7335 17.3333 20.4667 16.0668 20.4667C14.3333 20.4667 13.7333 19.7333 13.5334 18.7333C13.4668 18.4667 13.2668 18.3333 13.0668 18.3333H11.9334C11.6668 18.3333 11.4668 18.5333 11.4668 18.8V18.8667C11.7334 20.5333 12.8001 21.7333 15.0001 22.0667V23.6667C15.0001 23.9333 15.2001 24.1333 15.5333 24.2H16.5333C16.8001 24.2 17.0001 24 17.0668 23.6667V22.0667C19.0668 21.7333 20.4 20.3333 20.4 18.5333Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6003 25.5333C7.40032 23.6667 4.7336 17.8667 6.66704 12.7333C7.66704 9.93331 9.86704 7.80003 12.6003 6.80003C12.867 6.66675 13.0003 6.46675 13.0003 6.13331V5.20003C13.0003 4.93331 12.867 4.73331 12.6003 4.66675C12.5336 4.66675 12.4003 4.66675 12.3336 4.73331C6.00032 6.73331 2.5336 13.4667 4.5336 19.8C5.7336 23.5333 8.60032 26.4 12.3336 27.6C12.6003 27.7333 12.867 27.6 12.9336 27.3333C13.0003 27.2667 13.0003 27.2 13.0003 27.0667V26.1333C13.0003 25.9333 12.8003 25.6667 12.6003 25.5333ZM19.667 4.73331C19.4003 4.60003 19.1336 4.73331 19.067 5.00003C19.0003 5.06675 19.0003 5.13331 19.0003 5.26675V6.20003C19.0003 6.46675 19.2003 6.73331 19.4003 6.86675C24.6003 8.73331 27.267 14.5333 25.3336 19.6667C24.3336 22.4667 22.1336 24.6 19.4003 25.6C19.1336 25.7333 19.0003 25.9333 19.0003 26.2667V27.2C19.0003 27.4667 19.1336 27.6667 19.4003 27.7333C19.467 27.7333 19.6003 27.7333 19.667 27.6667C26.0003 25.6667 29.467 18.9333 27.467 12.6C26.267 8.80003 23.3336 5.93331 19.667 4.73331Z",
  fill: "white"
});

function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/USDC.866d7d8df207d4231860530f2ee921ee.svg";
export { ForwardRef as ReactComponent };